var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"columns is-mobile is-centered"},[(!_vm.loading)?_c('div',{staticClass:"column is-half"},[_vm._v(" "+_vm._s(_vm.$t('status.success'))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }